<template>
  <div id="custom-online">
    <Breadcrumb></Breadcrumb>
    <div style="text-align: right; margin: 8px 0 12px 0">
      <el-button @click="handleSubmitForm('03')" size="small"
        >保存到待发布</el-button
      >
      <el-button type="primary" @click="handleSubmitForm('01')" size="small"
        >立即发布</el-button
      >
    </div>
    <input
      v-show="false"
      type="file"
      id="fileUpload"
      name="file"
      @change="handleSaveFile"
    />
    <el-form
      :model="form"
      ref="form"
      label-width="170px"
      :rules="rules"
      class="product-form"
    >
      <div class="t_plane self_el_item_form">
        <div class="pl_til">产品类型</div>
        <div class="pl_content">
          <el-form-item label="产品类型：" prop="productType">
            <el-radio-group v-model="form.productType">
              <el-radio
                v-for="(value, key, index) in dictData['product_type']"
                :key="index"
                :label="value.value"
                :value="value.value"
                >{{ value.label }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
      </div>
      <div class="t_plane self_el_item_form">
        <div class="pl_til">产品信息</div>
        <div class="pl_content">
          <el-form-item
            v-if="form.productType === '01'"
            label="关联产品："
            prop="relaPId"
          >
            <el-input v-model="form.relaPId" size="small"></el-input>
          </el-form-item>
          <el-form-item
            v-if="form.productType === '01'"
            label="工厂编号："
            prop="proCode"
          >
            <el-input v-model="form.proCode" size="small"></el-input>
          </el-form-item>
          <el-form-item
            v-if="form.productType === '02'"
            label="关联设计："
            prop="designId"
          >
            <el-input
              v-model="form.designId"
              size="small"
              maxlength="100"
            ></el-input>
          </el-form-item>
          <el-form-item label="中文名称：" prop="proName">
            <el-input
              v-model="form.proName"
              size="small"
              maxlength="100"
            ></el-input>
            <div style="position:absolute;left:620px;top: 0px;width: 200px;">
              {{ form.proCode }}
              <span
                @click="handleCopyText(form.proCode)"
                style="margin: 0 0 0 8px;color:#4934b2;cursor:pointer;"
                >复制</span
              >
            </div>
          </el-form-item>
          <el-form-item label="英文名称：" prop="engProName">
            <el-input
              v-model="form.engProName"
              size="small"
              maxlength="100"
            ></el-input>
          </el-form-item>
          <el-form-item label="产品分类：" prop="typeId">
            <TreeSelect
              :props="treeSelectProps"
              :options="productTypeList"
              v-model="form.typeId"
              ref="childSelTree"
              @getValue="getTreeNodeId"
              style="width: 100%"
            ></TreeSelect>
          </el-form-item>
          <el-form-item
            label="生产工艺："
            style="margin-top: 20px"
            prop="prodTech"
          >
            <el-input
              v-model="form.prodTech"
              size="small"
              maxlength="100"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="产品材质："
            style="margin-top: 20px"
            prop="pdMaterial"
          >
            <el-input
              v-model="form.pdMaterial"
              size="small"
              maxlength="100"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="form.productType === '01'"
            label="生产时长："
            style="margin-top: 20px"
            prop="prodDays"
          >
            <el-select
              clearable
              v-model="form.prodDays"
              placeholder="请选择"
              size="small"
              style="width: 100%"
            >
              <el-option
                v-for="(value, index) in dictData['prod_days']"
                :key="index"
                :label="value.label"
                :value="value.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="生产产商："
            style="margin-top: 20px"
            prop="manufacturer"
          >
            <el-select
              clearable
              v-model="form.manufacturer"
              placeholder="请选择"
              size="small"
              style="width: 100%"
            >
              <el-option
                v-for="(value, index) in dictData['MANUFACTURER']"
                :key="index"
                :label="value.label"
                :value="value.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="所属国家："
            style="margin-top: 20px"
            prop="state"
          >
            <el-select
              clearable
              v-model="form.state"
              placeholder="请选择"
              size="small"
              style="width: 100%"
            >
              <el-option
                v-for="(value, index) in dictData['country_site']"
                :key="index"
                :label="value.label"
                :value="value.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="标签属性："
            style="margin-top: 20px"
            prop="labelAttr"
          >
            <el-checkbox-group v-model="form.labelAttr" size="small">
              <div
                style="display: inline-block; margin: 0 16px 0 0; float: left"
                :key="count"
                v-for="(item, count) in labelAttrList"
                :style="{
                  clear:
                    item.value.length == 2 && count > 1 ? 'both' : 'inherit',
                }"
              >
                <el-checkbox
                  v-if="item.value.length == 4"
                  :label="item.value"
                  >{{ item.label }}</el-checkbox
                >
                <span style="font-size: 14px; color: #606266" v-else>{{
                  item.label
                }}</span>
              </div>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item
            label="产品特性："
            style="margin-top: 20px"
            prop="features"
          >
            <el-radio-group v-model="form.features">
              <template v-for="(value, key) in dictData['FEATURES']">
                <el-radio :label="value.value" :key="value.value">
                  {{ value.label }}</el-radio
                >
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="性别：" style="margin-top: 20px" prop="sex">
            <el-radio-group v-model="form.sex">
              <template v-for="(value, key) in dictData['sys_user_sex']">
                <el-radio :label="value.value" :key="value.value">
                  {{ value.label }}</el-radio
                >
              </template>
            </el-radio-group>
          </el-form-item>

          <el-form-item
            label="畅销类型："
            style="margin-top: 20px"
            prop="saleType"
          >
            <el-checkbox-group v-model="form.saleType" size="small">
              <el-checkbox label="1">热销</el-checkbox>
              <el-checkbox label="2">新品</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="销量：" style="margin-top: 20px" prop="sales">
            <el-input
              v-model="form.sales"
              size="small"
              maxlength="100"
            ></el-input>
          </el-form-item>
          <el-form-item label="价格：" style="margin-top: 20px" prop="price">
            <el-input
              v-model="form.price"
              size="small"
              maxlength="100"
            ></el-input>
          </el-form-item>
          <el-form-item label="重量：" style="margin-top: 20px" prop="weight">
            <el-input
              v-model="form.weight"
              size="small"
              maxlength="100"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="80%平均时效(小时)："
            style="margin-top: 20px"
            prop="mostDelivery"
          >
            <el-input
              v-model="form.mostDelivery"
              size="small"
              maxlength="100"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="平均发货时效(小时)："
            style="margin-top: 20px"
            prop="avgDelivery"
          >
            <el-input
              v-model="form.avgDelivery"
              size="small"
              maxlength="100"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="生产商承诺发货(小时)："
            style="margin-top: 20px"
            prop="agreeDelivery"
          >
            <el-input
              v-model="form.agreeDelivery"
              size="small"
              maxlength="100"
            ></el-input>
          </el-form-item>
          <el-form-item label="起订数量：" style="margin-top: 20px" prop="moq">
            <el-input
              v-model="form.moq"
              size="small"
              maxlength="100"
            ></el-input>
          </el-form-item>
          <el-form-item label="排序" style="margin-top: 20px" prop="sort">
            <el-input
              v-model="form.sort"
              size="small"
              maxlength="100"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="VIP等级："
            style="margin-top: 20px"
            prop="vipType"
          >
            <el-select
              clearable
              v-model="form.vipType"
              placeholder="请选择"
              size="small"
              style="width: 100%"
            >
              <el-option
                v-for="(value, index) in dictData['vipType']"
                :key="index"
                :label="value.label"
                :value="value.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="指定商家："
            style="margin-top: 20px"
            prop="busiList"
          >
            <el-select
              filterable
              multiple
              clearable
              remote
              :remote-method="getMerchantList"
              v-model="form.busiList"
              placeholder="请选择"
              size="small"
              style="width: 100%"
            >
              <el-option
                v-for="(value, index) in merchantList"
                :key="index"
                :label="value.userName"
                :value="value.userName"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注：" style="margin-top: 20px" prop="busiList">
            <el-input
              v-model="form.remark"
              size="small"
              maxlength="100"
            ></el-input>
          </el-form-item>
        </div>
      </div>
      <!--刺绣价格-->
      <div class="t_plane self_el_item_form">
        <div class="pl_til">刺绣折扣</div>
        <div class="pl_content">
          <div class="sku-list">
            <el-table
              id="outTable"
              ref="table"
              :data="embroideryList"
              tooltip-effect="dark"
              style="width: 100%"
              :header-cell-style="{ 'text-align': 'center' }"
            >
              <el-table-column width="100px" label="序号" align="center">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column label="低数量" align="center">
                <template slot-scope="scope">
                  <el-input
                    size="small"
                    onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d*(\.?\d{0,2})/g,'');"
                    v-model="scope.row.lowNum"
                    maxlength="100"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column label="高数量" align="center">
                <template slot-scope="scope">
                  <el-input
                    size="small"
                    onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d*(\.?\d{0,2})/g,'');"
                    v-model="scope.row.highNum"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column label="折扣" align="center">
                <template slot-scope="scope">
                  <el-input
                    size="small"
                    onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d*(\.?\d{0,2})/g,'');"
                    v-model="scope.row.discount"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column width="150px" label="操作" align="center">
                <template slot-scope="scope">
                  <el-button @click="handleAddRow(scope.row)" type="text"
                    >增加</el-button
                  >
                  <el-button
                    v-if="scope.$index > 0"
                    @click="handleDeleteRow(scope.$index)"
                    type="text"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <!--SKU信息-->
      <div class="t_plane self_el_item_form">
        <div class="pl_til">SKU信息</div>
        <div class="pl_content">
          <div class="color-list">
            <div
              style="display: inline-block; font-size: 14px; margin: 0 8px 0 0"
            >
              颜色：
            </div>
            <el-tag
              :key="tag"
              v-for="tag in colorTags"
              closable
              :disable-transitions="false"
              @close="handleColorClose(tag)"
            >
              {{ tag }}
            </el-tag>
            <el-select
              filterable
              size="small"
              ref="saveTagColorInput"
              @change="handleColorInputConfirm"
              v-model="inputColorValue"
              v-if="inputColorVisible"
              style="margin: 0 0 0 8px"
            >
              <el-option
                v-for="(record, index) in dictData['color']"
                :value="record.value"
                :label="record.value"
                :key="index"
              ></el-option>
            </el-select>
            <el-button
              v-else
              class="button-new-tag"
              size="small"
              @click="showColorInput"
              >+ 新增颜色</el-button
            >
          </div>
          <div class="size-list">
            <div
              style="display: inline-block; font-size: 14px; margin: 0 8px 0 0"
            >
              尺寸：
            </div>
            <el-tag
              :key="tag"
              v-for="tag in sizeTags"
              closable
              :disable-transitions="false"
              @close="handleSizeClose(tag)"
            >
              {{ tag }}
            </el-tag>
            <el-input
              class="input-new-tag"
              v-if="inputSizeVisible"
              v-model="inputSizeValue"
              ref="saveTagSizeInput"
              size="small"
              @keyup.enter.native="handleSizeInputConfirm"
              @blur="handleSizeInputConfirm"
            >
            </el-input>
            <el-button
              v-else
              class="button-new-tag"
              size="small"
              @click="showSizeInput"
              >+ 新增尺寸</el-button
            >
          </div>
          <div class="sku-list">
            <el-table
              id="outTable"
              ref="table"
              :data="skuList"
              tooltip-effect="dark"
              style="width: 100%"
              :header-cell-style="{ 'text-align': 'center' }"
            >
              <el-table-column prop="name" label="变种信息" align="center">
                <template slot-scope="scope">
                  <div v-html="scope.row.properVal"></div>
                </template>
              </el-table-column>
              <el-table-column label="SKU" align="center">
                <template slot-scope="scope">
                  <el-input
                    size="small"
                    v-model="scope.row.proSkuNo"
                    maxlength="100"
                    :disabled="true"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column label="重量" align="center">
                <template slot="header">
                  重量(g)<br />(<span
                    @click="handleShowPriceDialog('weight')"
                    class="primary-color pointer"
                    >一键设置</span
                  >)
                </template>
                <template slot-scope="scope">
                  <el-input
                    size="small"
                    onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d*(\.?\d{0,2})/g,'');"
                    v-model="scope.row.weight"
                    maxlength="100"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column label="成本价" align="center">
                <template slot="header">
                  成本价<br />(<span
                    @click="handleShowPriceDialog('costPrice')"
                    class="primary-color pointer"
                    >一键设置</span
                  >)
                </template>
                <template slot-scope="scope">
                  <el-input
                    size="small"
                    onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d*(\.?\d{0,2})/g,'');"
                    v-model="scope.row.costPrice"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column label="零售价" align="center">
                <template slot="header">
                  零售价<br />(<span
                    @click="handleShowPriceDialog('sellPrice')"
                    class="primary-color pointer"
                    >一键设置</span
                  >)
                </template>
                <template slot-scope="scope">
                  <el-input
                    size="small"
                    onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d*(\.?\d{0,2})/g,'');"
                    v-model="scope.row.sellPrice"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column label="最低价" align="center">
                <template slot="header">
                  最低价<br />(<span
                    onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d*(\.?\d{0,2})/g,'');"
                    @click="handleShowPriceDialog('lowPrice')"
                    class="primary-color pointer"
                    >一键设置</span
                  >)
                </template>
                <template slot-scope="scope">
                  <el-input
                    size="small"
                    v-model="scope.row.lowPrice"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column width="290px" label="折扣价">
                <template slot="header">
                  折扣价<br />(<span
                    @click="handleShowPriceDialog('discountPrice')"
                    class="primary-color"
                    >一键设置</span
                  >)
                </template>
                <template slot-scope="scope">
                  <div class="price-set">
                    <div
                      v-for="(record, index) in scope.row.priceList"
                      :key="index"
                      style="margin-bottom: 4px"
                    >
                      <el-input
                        size="mini"
                        style="width: 60px"
                        v-model="record.lowNum"
                        onkeyup="this.value=this.value.replace(/[^\d]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d*(\.?\d{0,2})/g,'');"
                      >
                        <span slot="suffix">件</span> </el-input
                      >~<el-input
                        size="mini"
                        style="width: 60px; margin-right: 8px"
                        v-model="record.highNum"
                        onkeyup="this.value=this.value.replace(/[^\d]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d*(\.?\d{0,2})/g,'');"
                      >
                        <span slot="suffix">件</span></el-input
                      >
                      <el-input
                        size="mini"
                        onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d*(\.?\d{0,2})/g,'');"
                        style="width: 60px; margin-right: 8px"
                        v-model="record.price"
                      >
                        <span slot="suffix">元</span></el-input
                      >

                      <i
                        style="margin-right: 2px"
                        v-if="scope.row.priceList.length > 1"
                        @click="handleDeletePrice(scope.row.priceList, index)"
                        class="el-icon-remove-outline"
                      ></i>
                      <i
                        v-if="
                          scope.row.priceList.length < 5 &&
                            index === scope.row.priceList.length - 1
                        "
                        @click="handleAddPrice(scope.row.priceList, index)"
                        class="el-icon-circle-plus-outline"
                      ></i>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="库存" align="center">
                <template slot="header">
                  库存<br />(<span
                    @click="handleShowPriceDialog('stock')"
                    class="primary-color pointer"
                    >一键设置</span
                  >)
                </template>
                <template slot-scope="scope">
                  <el-input
                    size="small"
                    onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d*(\.?\d{0,2})/g,'');"
                    v-model="scope.row.stock"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column width="60px" label="启用" align="center">
                <template slot-scope="scope">
                  <el-switch v-model="scope.row.skuStatus"> </el-switch>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

      <!--变种图片-->
      <div class="t_plane self_el_item_form">
        <div class="pl_til">变种图片</div>
        <div class="pl_content">
          <div v-for="(value, key) in picList" :key="key" class="color-content">
            <div class="pl-title">变种信息：{{ key }}</div>
            <ul
              class="extra-image-ul letter w70 detail-image-ul amazon sort-img active"
            >
              <draggable
                :list="value"
                style="overflow: hidden"
                filter=".forbid"
                @start="drag = true"
                @end="drag = false"
                :move="onMove"
              >
                <li
                  v-for="(record, index) in value"
                  :key="index"
                  class="sort-img-item"
                  :class="index === 0 ? 'forbid' : ''"
                >
                  <div v-if="record.isMain == '1'" class="item-badge">
                    主图1
                  </div>
                  <div v-if="record.isMain == '2'" class="item-badge">
                    主图2
                  </div>
                  <div v-if="record.isMain == '3'" class="item-badge">
                    尺码表
                  </div>
                  <img :src="record.picUrl" />
                  <span class="first-pro-icon icon-corner-mark"></span>
                  <div class="wish-product-img-ope">
                    <div style="width: 100%; overflow: hidden">
                      <a
                        v-if="record.isMain == '0' || !record.isMain"
                        @click.prevent="handleSetMainImage1(value, index)"
                        class="set-main"
                        style="margin: 0 8px 0 0"
                        >主图1</a
                      >
                      <a
                        v-if="record.isMain == '0' || !record.isMain"
                        @click.prevent="handleSetMainImage2(value, index)"
                        class="set-main"
                        >主图2</a
                      >
                      <a
                        v-if="record.isMain == '0' || !record.isMain"
                        @click.prevent="handleSetSizeImage(value, index)"
                        class="set-main"
                        style="margin: 0 8px 0 0"
                        >尺码表</a
                      >
                      <a
                        @click.prevent="hanldeDeleteImage(value, index)"
                        class="set-main"
                        style="margin: 0 8px 0 0"
                        >移除</a
                      >
                      <a
                        v-if="
                          record.isMain == '2' ||
                            record.isMain == '1' ||
                            record.isMain == '3'
                        "
                        @click.prevent="handleUnSetSizeImage(value, index)"
                        class="set-main"
                        >取消</a
                      >
                    </div>
                  </div>
                </li>
                <li
                  @click="handleUploadImage(key)"
                  v-if="value && value.length < 9"
                  class="sort-img-item add-image-button forbid"
                >
                  <p><i class="el-icon-plus"></i></p>
                </li>
              </draggable>
            </ul>
          </div>
        </div>
      </div>

      <!--描述信息-->
      <div class="t_plane self_el_item_form">
        <div class="pl_til">描述信息</div>
        <div class="pl_content">
          <el-form-item class="wd100" label="产品描述：">
            <CKEditor4
              v-model="form.remarks"
              :config="editorConfig"
              @getCkEditorInstance="getEditor"
              @input="handleChangeEditor"
              @open="openUploadDialog"
            ></CKEditor4>
          </el-form-item>
          <el-form-item class="wd100" label="英文描述：">
            <el-input
              type="textarea"
              :rows="5"
              v-model="form.engProductDesc"
              placeholder="请输入内容"
              size="mini"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="form.productType === '01'"
            class="wd100"
            label="设计提示："
          >
            <el-input
              type="textarea"
              :rows="5"
              v-model="form.desiHint"
              placeholder="请输入内容"
              size="mini"
            ></el-input>
          </el-form-item>
          <el-form-item class="wd100" label="温馨提示：">
            <el-input
              type="textarea"
              :rows="5"
              v-model="form.reminder"
              placeholder="请输入内容"
              size="mini"
            ></el-input>
          </el-form-item>
        </div>
      </div>

      <div class="t_plane self_el_item_form">
        <div class="pl_til">产品尺码</div>
        <div class="pl_content">
          <el-table
            id="outTable"
            ref="table"
            :data="sizeData"
            tooltip-effect="dark"
            style="width: 100%"
            :header-cell-style="{ 'text-align': 'center' }"
          >
            <el-table-column prop="name" label="变种信息" align="center">
              <template slot-scope="scope">
                {{ scope.row.skuSelect }}
              </template>
            </el-table-column>
            <el-table-column prop="name" label="属性1" align="center">
              <template slot-scope="scope">
                <el-input
                  size="small"
                  v-model="scope.row.attrValue1"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="属性2" align="center">
              <template slot-scope="scope">
                <el-input
                  size="small"
                  v-model="scope.row.attrValue2"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="属性3" align="center">
              <template slot-scope="scope">
                <el-input
                  size="small"
                  v-model="scope.row.attrValue3"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="属性4" align="center">
              <template slot-scope="scope">
                <el-input
                  size="small"
                  v-model="scope.row.attrValue4"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="属性5" align="center">
              <template slot-scope="scope">
                <el-input
                  size="small"
                  v-model="scope.row.attrValue5"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="属性6" align="center">
              <template slot-scope="scope">
                <el-input
                  size="small"
                  v-model="scope.row.attrValue6"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="属性7" align="center">
              <template slot-scope="scope">
                <el-input
                  size="small"
                  v-model="scope.row.attrValue7"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="属性8" align="center">
              <template slot-scope="scope">
                <el-input
                  size="small"
                  v-model="scope.row.attrValue8"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="属性9" align="center">
              <template slot-scope="scope">
                <el-input
                  size="small"
                  v-model="scope.row.attrValue9"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="属性10" align="center">
              <template slot-scope="scope">
                <el-input
                  size="small"
                  v-model="scope.row.attrValue9"
                ></el-input>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="t_plane self_el_item_form">
        <div class="pl_til">包装规格</div>
        <div class="pl_content">
          <el-table
            id="outTable"
            ref="table"
            :data="packageData"
            tooltip-effect="dark"
            style="width: 100%"
            :header-cell-style="{ 'text-align': 'center' }"
          >
            <el-table-column prop="name" label="变种信息" align="center">
              <template slot-scope="scope">
                {{ scope.row.skuSelect }}
              </template>
            </el-table-column>
            <el-table-column prop="name" label="属性1" align="center">
              <template slot-scope="scope">
                <el-input
                  size="small"
                  v-model="scope.row.attrValue1"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="属性2" align="center">
              <template slot-scope="scope">
                <el-input
                  size="small"
                  v-model="scope.row.attrValue2"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="属性3" align="center">
              <template slot-scope="scope">
                <el-input
                  size="small"
                  v-model="scope.row.attrValue3"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="属性4" align="center">
              <template slot-scope="scope">
                <el-input
                  size="small"
                  v-model="scope.row.attrValue4"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="属性5" align="center">
              <template slot-scope="scope">
                <el-input
                  size="small"
                  v-model="scope.row.attrValue5"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="属性6" align="center">
              <template slot-scope="scope">
                <el-input
                  size="small"
                  v-model="scope.row.attrValue6"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="属性7" align="center">
              <template slot-scope="scope">
                <el-input
                  size="small"
                  v-model="scope.row.attrValue7"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="属性8" align="center">
              <template slot-scope="scope">
                <el-input
                  size="small"
                  v-model="scope.row.attrValue8"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="属性9" align="center">
              <template slot-scope="scope">
                <el-input
                  size="small"
                  v-model="scope.row.attrValue9"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="属性10" align="center">
              <template slot-scope="scope">
                <el-input
                  size="small"
                  v-model="scope.row.attrValue10"
                ></el-input>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-form>

    <el-dialog
      :close-on-click-modal="false"
      :title="
        `修改${
          this.priceType === 'weight'
            ? '重量'
            : this.priceType === 'stock'
            ? '库存'
            : '价格'
        }`
      "
      :visible.sync="showPriceDialog"
      width="560px"
      @close="handleClosePriceDialog"
    >
      <el-row style="margin-top: 15px; margin-left: 15px">
        {{
          this.priceType === "weight"
            ? "重量"
            : this.priceType === "stock"
            ? "库存"
            : "价格"
        }}：
        <el-input
          v-model.trim="priceModify"
          onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d*(\.?\d{0,2})/g,'');"
          :title="
            `请输入${
              this.priceType === 'weight'
                ? '重量'
                : this.priceType === 'stock'
                ? '库存'
                : '价格'
            }}`
          "
          size="mini"
          style="width: 450px"
        ></el-input>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClosePriceDialog" size="small"
          >取 消</el-button
        >
        <el-button type="primary" @click="handleUpdatePrice" size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <LocalUpload :ckData="localUploadData"></LocalUpload>
    <OnlineUpload :ckData="onlineUploadData"></OnlineUpload>
  </div>
</template>

<script type="text/ecmascript-6">
import Breadcrumb from '@/components/common/Breadcrumb'
import ElRow from "element-ui/packages/row/src/row";
import CKEditor4 from '@/components/common/CKEditor'
import TreeSelect from '@/components/common/treeSelect';
import { getProductTypeTree } from "@/api/product/type";
import { addProduct, getProductDetail , getEditInfo } from "@/api/customProduct/product";
import draggable from "vuedraggable"
import LocalUpload from "@/components/common/ckEditorUploadPage/localUpload"
import OnlineUpload from "@/components/common/ckEditorUploadPage/onlineUpload"
import { listUser, editUser } from "@/api/business/merchantManage"
import {mapGetters} from 'vuex'
import { getOSSToken } from "@/api/setting";
import { getDesign } from "@/api/customProduct/design"

export default {
    name: "product",
    components:{
        ElRow,
        Breadcrumb,
        CKEditor4,
        TreeSelect,
        draggable,
        LocalUpload,
        OnlineUpload
    },
    computed: {
      ...mapGetters(["dictData", "dictMap"]),
    },
    data(){
      return{
        priceModify: '',
        form:{
          typeId: '',
          proCode: '',
          proName: '',
          engProName: '',
          prodTech: '',
          pdMaterial: '',
          prodDays: '',
          manufacturer: '',
          attribute: '',
          desiHint: '',
          reminder: '',
          engProductDesc: '',
          remarks: '',
          dzStatus: '',
          productType: '01',
          saleType: [],
          features: '',
          skuList: [],
          mostDelivery: '',
          avgDelivery: '',
          agreeDelivery: '',
          vipType: '',
          busiList: [],
          moq: '1',
          sort: '',
          sales: '',
          price: '',
          weight: '',
          remark: '',
          sex: '0',
          designId: '',
          labelAttr: [],
          relaPId: '',
          state: '',
        },
        productTypeList: [],
        treeSelectProps: {
          value:'typeId',             // ID字段名
          label: 'typeName',         // 显示名称
          children: 'childrenTree'    // 子级字段名
        },
        colorTags: [],
        inputColorVisible: false,
        inputColorValue: '',
        sizeTags: [],
        inputSizeVisible: false,
        inputSizeValue: '',
        skuList: [],
        picList: {},
        embroideryList: [{
          lowNum : '',
          highNum: '',
          discount: ''
        }],
        currentColor: '',
        aliyunOssToken: {},
        sizeData: [{skuSelect: '尺码' , attrValue1: '',attrValue2: '',attrValue3: '',attrValue4: '',attrValue5: '',attrValue6: '',attrValue7: '',attrValue8: '',attrValue9: '',attrValue10: ''}],
        packageData: [{skuSelect: '尺码', attrValue1: '',attrValue2: '',attrValue3: '',attrValue4: '',attrValue5: '',attrValue6: '',attrValue7: '',attrValue8: '',attrValue9: '',attrValue10: ''}],
        rules: {
            productType: [
                {required: true, message: '请输入产品类型', trigger: 'change'},
            ],
            proCode: [
                {required: true, message: '请输入工厂编号', trigger: 'blur'},
            ],
            proName: [
                {required: true, message: '请输入中文名称', trigger: 'blur'},
            ],
            typeId: [
                {required: true, message: '请选择产品分类', trigger: 'blur'},
            ],
            prodTech: [
                {required: true, message: '请输入生产工艺', trigger: 'blur'},
            ],
            pdMaterial: [
                {required: true, message: '请输入产品材质', trigger: 'blur'},
            ],
            prodDays: [
                {required: true, message: '请输入生产时长', trigger: 'blur'},
            ],
            manufacturer: [
                {required: true, message: '请输入生产厂商', trigger: 'blur'},
            ],
            price: [
                { required: true, message: '请输入价格', trigger: 'blur' },
            ],
            moq: [
                { required: true, message: '请输入起订数量', trigger: 'blur' },
            ],
            commSku: [
                { required: true, message: '请输入SKU', trigger: 'blur' },
            ],
            packWeight: [
                { required: true, message: '请输入包装重量', trigger: 'blur' },
            ],
            packLong: [
                { required: true, message: '请输入包装尺寸长', trigger: 'blur' },
            ],
            packWide: [
                { required: true, message: '请输入包装尺寸宽', trigger: 'blur' },
            ],
            packHigh: [
                { required: true, message: '请输入包装尺寸高', trigger: 'blur' },
            ],
            vipType: [
                { required: true, message: '请输入VIP等级', trigger: 'blur' },
            ],
            sales: [
                { required: true, message: '请输入销量', trigger: 'blur' },
            ],
            price: [
                { required: true, message: '请输入价格', trigger: 'blur' },
            ],
            weight: [
                { required: true, message: '请输入重量', trigger: 'blur' },
            ],
            features: [
                { required: true, message: '请输入产品特性', trigger: 'blur' },
            ],
            state: [
                { required: true, message: '请输入所属国家', trigger: 'blur' },
            ],
        },
        labelAttrList: [],
        merchantList: [],
        showPriceDialog: false,
        //描述文本框
        editor:null,
        editorConfig: {
        allowedContent: true, //设置为true，以防止CKEditor 4删除不允许的元素
        extraPlugins: ["uploadImg"],
        height: "300px",
        toolbar: [
          ["Maximize"],
          ["Bold", "Italic", "Underline", "Strike"],
          ["TextColor", "BGColor"],
          [
            "JustifyLeft",
            "JustifyCenter",
            "JustifyRight",
            "JustifyBlock",
            "-",
            "NumberedList",
            "BulletedList",
            "-",
            "Outdent",
            "Indent",
            "-",
            "Subscript",
            "Superscript",
          ],
          ["HorizontalRule", "RemoveFormat"],
          ["Undo", "Redo"],
          "/",
          ["Styles", "Format", "Font", "FontSize"],
          ["Table"],
          ["uploadImg"],
        ],

        language: "zh-cn",
        wordcount: {
          showCharCount: true,
        },
        },
       localUploadData: {
          visible: false,
          editor: null,
        },
        onlineUploadData: {
          visible: false,
          editor: null,
        },
        priceType: '',
        domain: ''
      }
    },
    async created() {
      await this.getProductTypeTree()
      // this.getMerchantList()
      this.getOssToken()
      let pId = this.$route.query.pId
            let designId = this.$route.query.designId
      if(pId){
        let result = await getEditInfo(pId)
        let data = result.data
        let form = this._.pick(data, 'basicId', 'proCode', 'proName', 'engProName', 'prodTech', 'pdMaterial','busiList','vipType', 'moq', 'sort',
         'prodDays', 'manufacturer', 'desiHint', 'reminder', 'remarks', 'dzStatus', 'productType', 'saleType','features', 'typeId',  'mostDelivery','avgDelivery', 'agreeDelivery',
        'sales','price','sex', 'weight' , 'remark', 'designId', 'labelAttr' , 'engProductDesc' , 'embroideryList', 'relaPId', 'state');
        form.saleType = form.saleType.split(',')

        if(!form.features){
          form.features = ''
        }
        if(!form.labelAttr){
          form.labelAttr = []
        }else{
          form.labelAttr = form.labelAttr.split(',')
        }
        form.pId = pId
        if(form.busiList){
          let busiList = []
          for(let record of form.busiList){
            busiList.push(record.userName)
          }
          form.busiList = busiList
        }
        if(!form.embroideryList || form.embroideryList.length == 0){
          form.embroideryList = [{
            lowNum : '',
            highNum: '',
            discount: ''
          }]
        }
        this.form = form
        this.form.desiHint = this.form.desiHint ? this.form.desiHint.replace(/<br>/g, '\n') : ''
        this.form.reminder = this.form.reminder ? this.form.reminder.replace(/<br>/g, '\n') : ''
        this.form.engProductDesc = this.form.engProductDesc ? this.form.engProductDesc.replace(/<br>/g, '\n') : ''
        this.form.remark = this.form.remark ? this.form.remark.replace(/<br>/g, '\n') : ''
        this.packageData = data.packList
        this.sizeData = data.sizeList
        let attribute = JSON.parse(data.attribute)
        this.colorTags = attribute['颜色']
        this.sizeTags = attribute['尺码']
        this.embroideryList = this.form.embroideryList
        //开始渲染SKU信息
        let picList =  {}
        for(let record of data.skuList){
          let row = this._.pick(record,'properName', 'properVal','proSkuNo','proSkuId', 'weight', 'priceList', 'costPrice', 'sellPrice' ,'lowPrice', 'skuStatus', 'stock')
          let color = row.properVal.split(':')[0]
          if(!picList[color]){
            picList[color] = record.picList
          }
          this.skuList.push({
              color: color,
              properName: '颜色:尺码',
              weight: row.weight,
              properVal: row.properVal,
              proSkuId:  row.proSkuId,
              proSkuNo:  row.proSkuNo,
              costPrice: row.costPrice,//成本价
              sellPrice: row.sellPrice, //零售价
              lowPrice: row.lowPrice,//最低价
              priceList: row.priceList,
              stock: row.stock,
              skuStatus: row.skuStatus == "1" ? true : false
          })
        }
        this.picList = picList
      }
      if(designId){
        this.form.productType = '02'
        this.form.designId = designId
        let designInfo = await getDesign(designId)
        this.form.proName = designInfo.data.proName
        this.form.engProName = designInfo.data.engProName

        let picList =  {}
        for(let record of designInfo.data.skuList){
          let row = this._.pick(record,'properName', 'properVal')
          let color = row.properVal.split(':')[0]
          if(!picList[color]){
            picList[color] = record.picList
            for(let i = 0;i< record.picList.length;i++){
              if(i == 0){
                record.picList[i].isMain = '1'
              }else{
                record.picList[i].isMain = '0'
              }
            }
          }
        }
        this.picList = picList
      }
      //开始渲染attrList标签
      let labelAttrList = []
      let LABEL_ATTR = this.dictData['LABEL_ATTR']
      for(let record of LABEL_ATTR){
        if(record.value.length == 4){
          record.weight = Number(record.value)
        } if(record.value.length == 2){
          record.weight = Number(record.value) * 100
        }
      }
      labelAttrList = this._.sortBy(LABEL_ATTR, function(item){
        return Number(item.weight)
      })
      this.labelAttrList = labelAttrList
    },
    methods:{
      onMove(e){
        if(!e.relatedContext.element){
          return false
        }
        if(e.relatedContext.element.isMain){
          return false
        }
        return true
      },
      handleUpdatePrice(){
        for(let record of this.skuList){
          if(this.priceType === 'costPrice'){
            record.costPrice = this.priceModify
          }else if(this.priceType === 'sellPrice'){
            record.sellPrice = this.priceModify
          } else if(this.priceType === 'lowPrice'){
            record.lowPrice = this.priceModify
          } else if(this.priceType === 'weight'){
            record.weight = this.priceModify
          } else if(this.priceType === 'stock'){
            record.stock = this.priceModify
          } else if(this.priceType === 'discountPrice'){
            for(let item of record.priceList){
              item.price = this.priceModify
            }
          }
        }
        this.showPriceDialog = false
      },
      handleClosePriceDialog(){
        this.showPriceDialog = false
      },
      handleShowPriceDialog(priceType){
        this.priceModify = ''
        this.showPriceDialog = true
        this.priceType = priceType
      },
      handleAddRow(){
        this.embroideryList.push({
          lowNum : '',
          highNum: '',
          discount: ''
        })
      },
      handleDeleteRow(index){
        this.embroideryList.splice(index)
      },
      async handleSubmitForm(dzStatus){
          this.$refs['form'].validate(async (valid) => {
          if (valid) {
              let form = JSON.parse(JSON.stringify(this.form))
              let busiList = []
              for(let record of form.busiList){
                busiList.push({userName: record})
              }
              form.busiList = busiList
              form.dzStatus = dzStatus
              form.remarks = this.editor.getData()
              form.saleType = form.saleType.join(',')
              form.labelAttr = form.labelAttr.join(',')
              let skuList = []
              let skuListClone = JSON.parse(JSON.stringify(this.skuList))
              let skuRepeat = {}
              for(let record of skuListClone){
                for(let key in this.picList){
                  if(!record.picList && key === record.color){
                    record.picList = this._.clone(this.picList[key])
                    for(let item of record.picList){
                      if(item.isMain === "0" || item.isMain === "1" || item.isMain === "2" || item.isMain === "3"){
                        continue
                      }
                      item.isMain = item.isMain ? "1" : "0"
                    }
                    break
                  }
                }

                let i = 1
                for(let price of record.priceList){
                  price.gear = i
                  i++
                }
                record.skuStatus = record.skuStatus ? "1" : "0"
                record.proSkuId = record.proSkuId ? record.proSkuId : ''
                skuList.push(record)
              }
              form.skuList = skuList
              let i = 0
              this.sizeData.map((item)=>{
                item.sort = i
                i++
              })
              i = 0
              this.packageData.map((item)=>{
                item.sort = i
                i++
              })
              form.desiHint = form.desiHint.replace(/\n/g,'<br>')
              form.reminder = form.reminder.replace(/\n/g,'<br>')
              form.engProductDesc = form.engProductDesc.replace(/\n/g,'<br>')
              form.remark = form.remark.replace(/\n/g,'<br>')
              form.sizeList = this.sizeData
              form.packList = this.packageData
              form.attribute = JSON.stringify({
                '尺码': this.sizeTags,
                '颜色': this.colorTags
              })
              form.embroideryList = this.embroideryList

              try {
                let designId = this.$route.query.designId
                if(designId){
                  form.pId = ''
                  for(let record of form.skuList){
                    record.proSkuId = ''
                    record.proSkuNo = ''
                  }
                  for(let record of form.packList){
                    record.packId = ''
                  }
                  for(let record of form.sizeList){
                    record.sizeId = ''
                  }
                }
                await addProduct(form)
                this.msgSuccess("保存成功");
                this.$router.push({ path: "/product_mng/manage/normalGoods", query: {
                  pageSize: this.$route.query.pageSize, pageNum: this.$route.query.pageNum
                } })
              } catch (error) {
              }
                } else {
                  console.log('error submit!!');
                  return false;
                }
        });


      },
       handleCopyText(text) {
      let target = document.createElement("input") //创建input节点
      target.value = text // 给input的value赋值
      document.body.appendChild(target)
      target.value = text // 修改文本框的内容
      target.select() // 选中文本
      document.execCommand("copy") // 执行浏览器复制命令
      this.msgSuccess("复制成功")
      document.body.removeChild(target)
    },
      async getProductTypeTree() {
        let result = await getProductTypeTree();
        this.productTypeList = result.data;
      },
      getTreeNodeId(value){
        this.form.typeId = value
      },
      handleAddPrice(row){
        row.push({
          lowNum:'',
          highNum: '',
          price: ''
        })
      },
      handleDeletePrice(row,index){
        row.splice(index, 1)
      },
      handleColorClose(tag) {
        this.colorTags.splice(this.colorTags.indexOf(tag), 1);
        delete this.picList[tag]
        this.renderSkuList();
      },
      showColorInput() {
        this.inputColorVisible = true;
        this.$nextTick(_ => {
          // this.$refs.saveTagColorInput.$refs.input.focus();
        });
      },
      handleColorInputConfirm() {
        let inputValue = this.inputColorValue;
        if(inputValue.trim() === ''){
          this.inputColorVisible = false;
          this.inputColorValue = '';
          return
        }
        if(this.colorTags.indexOf(inputValue) > -1){
          this.msgWarning('颜色名称已存在，请重新填写')
          return
        }
        if (inputValue) {
          this.colorTags.push(inputValue.trim());
        }
        this.inputColorVisible = false;
        this.inputColorValue = '';
        this.picList[inputValue] = []
        this.renderSkuList();

      },
      handleSizeClose(tag) {
        this.sizeTags.splice(this.sizeTags.indexOf(tag), 1);
        //只删除对应的SIZE
        for(let i = 0;i< this.sizeData.length;i++){
          if(this.sizeData[i].size === tag){
            this.packageData.splice(i,1)
            this.sizeData.splice(i,1)
            break
          }
        }
        this.renderSkuList();
      },
      showSizeInput() {
        this.inputSizeVisible = true;
        this.$nextTick(_ => {
          this.$refs.saveTagSizeInput.$refs.input.focus();
        });
      },
      handleSizeInputConfirm() {
        let inputValue = this.inputSizeValue;
        if(inputValue.trim() === ''){
          this.inputSizeVisible = false;
          this.inputSizeValue = '';
          return
        }
         if(this.sizeTags.indexOf(inputValue) > -1){
          this.msgWarning('标签名称已存在，请重新填写')
          return
        }
        if (inputValue) {
          this.sizeTags.push(inputValue.trim());
        }
        this.inputSizeVisible = false;
        this.inputSizeValue = '';
        this.packageData.push({skuSelect: inputValue, attrValue1: '',attrValue2: '',attrValue3: '',attrValue4: '',attrValue5: '',attrValue6: '',attrValue7: '',attrValue8: '',attrValue9: ''})
        this.sizeData.push({skuSelect: inputValue, attrValue1: '',attrValue2: '',attrValue3: '',attrValue4: '',attrValue5: '',attrValue6: '',attrValue7: '',attrValue8: '',attrValue9: ''})

        this.renderSkuList();
      },
      renderSkuList(){
        let skuList = this._.clone(this.skuList)
        this.skuList = []
        if(this.sizeTags.length === 0 || this.colorTags.length === 0){
          return
        }

        for(let color of this.colorTags){
          for(let size of this.sizeTags){
            let find = false
            for(let record of skuList){
              if(record.properVal ==  `${color}:${size}`){
                find = true
                this.skuList.push(record)
                break
              }
            }
            if(!find){
              this.skuList.push({
                color: color,
                properName: '颜色:尺码',
                properVal: `${color}:${size}`,
                proSkuNo: '',
                weight: '', //重量
                costPrice: '', //成本价
                sellPrice: '', //零售价
                lowPrice: '', //最低价
                priceList: [{
                  lowNum:'',
                  highNum: '',
                  price: ''
                  }
                ],
                stock: '',
                skuStatus: true
              })
            }
          }
        }
      },
      getEditor(value){
        this.editor = this.localUploadData.editor = this.onlineUploadData.editor = value
      },
      handleChangeEditor(value){
        // this.form.remarks = value
      },
      openUploadDialog(val) {
        if (val == "local") {
          this.localUploadData.visible = true
        } else if (val == "online") {
          this.onlineUploadData.visible = true
        }
      },
      handleSetMainImage1(list ,index){
        list.map(item=>{
          if(item.isMain == '1'){

          item.isMain = '0'
          }
        })
        list[index].isMain = '1'
        let record = list[index]
        //插入到第一个元素
        list.splice(index , 1)
        list.unshift(record)
      },
      handleSetMainImage2(list ,index){
        list.map(item=>{
          if(item.isMain == '2'){
            item.isMain = '0'
          }
        })
        list[index].isMain = '2'
        let record = list[index]
        //插入到第一个元素
        list.splice(index , 1)
        list.unshift(record)
      },
      handleSetSizeImage(list ,index){
        list[index].isMain = '3'
      },
      handleUnSetSizeImage(list ,index){
        list[index].isMain = '0'
      },
      hanldeDeleteImage(list, index){
        list.splice(index , 1)
        let haveMain = false
        for(let record of list){
          if(record.isMain === true){
            haveMain = true
          }
        }
        if(!haveMain){
          list[0].isMain = true
        }
      },
      handleUploadImage(color){
        this.currentColor = color;
        document.querySelector('#fileUpload').click()
      },
      getOssToken() {
        var _self = this
        getOSSToken()
        .then(function (res) {
          if (res.code == 200) {
            _self.aliyunOssToken = res.data
          } else {
            _self.$message.error(res.msg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
      },
      getMerchantList(query) {
        var _self = this
        listUser({userType: '01', userName: query.toLowerCase(), pageSize: 10, pageNum: 1})
        .then(function (res) {
          if (res.code == 200) {
            _self.merchantList = res.rows
          } else {
            _self.$message.error(res.msg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
      },
      handleSaveFile() {
        var _self = this
        var getSuffix = function (fileName) {
          var pos = fileName.lastIndexOf(".")
          var suffix = ""
          if (pos != -1) {
            suffix = fileName.substring(pos)
          }
          return suffix
        }

        var file = $("#fileUpload").val()
        if (file.length == 0) {
          alert("请选择文件")
        }

        var filename = new Date().getTime() + getSuffix(file)
        var formData = new FormData()

        //注意formData里append添加的键的大小写
        formData.append("key", _self.aliyunOssToken.dir + filename) //存储在oss的文件路径
        formData.append("OSSAccessKeyId", _self.aliyunOssToken.accessid) //accessKeyId
        formData.append("policy", _self.aliyunOssToken.policy) //policy
        formData.append("Signature", _self.aliyunOssToken.signature) //签名
        //如果是base64文件，那么直接把base64字符串转成blob对象进行上传就可以了

        formData.append("file", $("#fileUpload")[0].files[0])
        formData.append("success_action_status", 200) //成功后返回的操作码
        this.domain = _self.aliyunOssToken.host + "/"

        var url = _self.aliyunOssToken.host
        var fileUrl =
          _self.aliyunOssToken.host + "/" + _self.aliyunOssToken.dir + filename
        $.ajax({
          url: url,
          type: "POST",
          data: formData,
          // async: false,
          cache: false,
          contentType: false,
          processData: false,
          success: function (data) {
            _self.picList[_self.currentColor].push({
              picUrl: fileUrl,
              isMain: _self.picList[_self.currentColor].length === 0 ? true : false
            })
            let array =JSON.parse(JSON.stringify(_self.picList))
            _self.picList = array
            $("#fileUpload").val(null)
          },
          error: function (data) {
             $("#fileUpload").val(null)
          },
        })
    },
    }
}
</script>

<style lang="scss" scoped>
.headerBorder {
  border: 1px solid darkgrey;
}
.container {
  margin-top: 15px;
}
.main {
  border: 1px solid darkgrey;
  border-top: none;
  width: 100%;
}
.el-header {
  height: 40px;
}
.inputSize {
  width: 300px;
}
.image {
  width: 88px;
  display: block;
  height: 100px;
}
.product-form {
  background: #ffffff;
  padding: 16px;
  ::v-deep .el-form-item__content {
    width: 600px;
  }

  ::v-deep .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
  .wd100 {
    ::v-deep .el-form-item__content {
      width: calc(100% - 100px);
    }
  }
}
.pl_til {
  background-color: #ffffff;
  border-bottom: none;
  border-left: 4px solid #4934b2;
  padding: 0 0 0 15px;
  font-size: 15px;
  color: #333333;
  font-weight: inherit;
}
.t_plane {
  border: none;
  border-radius: 0px;
}
.color-list {
  margin: 0 0 16px 0;
}
.price-set {
  font-size: 16px;
}
.sku-list {
  margin: 8px 0 0 0;
}
.pl-title {
  font-size: 14px;
  margin: 0 0 8px 0;
}
.extra-image-ul > li,
.extra-image-ul > li {
  background: #eeeeee;
}
.sort-img-item {
  position: relative;
  width: 100px;
  height: 100px;
  display: inline-block;
  img {
    width: 100px;
    height: 100px;
    position: absolute;
    left: 0;
  }
}

.extra-image-ul li {
  width: 100px;
  height: 100px;
  margin-right: 8px;
  margin-bottom: 8px;
  border: 1px solid rgb(221, 221, 221);
  position: relative;
  text-align: center;
  display: inline-block;
}
.add-image-button {
  background: #ebeef5;
}
.add-image-button > p {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  line-height: 1.4;
  width: 110%;
  font-size: 20px;
}
.item-badge {
  position: absolute;
  color: rgb(255, 165, 79);
  font-weight: bold;
  font-size: 14px;
  top: 5px;
  left: 6px;
  // -ms-transform: rotate(-35deg);
  // -webkit-transform: rotate(-35deg);
  // transform: rotate(-35deg);
  -webkit-transition: 0 0.1s ease-in;
  -moz-transition: 0 0.1s ease-in;
  -o-transition: 0 0.1s ease-in;
  transition: transform 0.1s ease-in;
  z-index: 100;
}
li .wish-product-img-ope,
li .wish-product-img-ope,
li .wish-product-img-ope {
  width: calc(100% - 8px);
  padding: 1px 4px;
  background: rgb(73, 52, 178);
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 9;
  line-height: 20px;
  text-align: left;
  font-size: 12px;
  color: #ffffff;
  a {
    color: #ffffff;
  }
  .set-main {
    float: left;
    cursor: pointer;
  }
  .set-delete {
    float: right;
    cursor: pointer;
  }
}
.price-set {
  ::v-deep .el-input--suffix .el-input__inner {
    padding-right: 16px;
  }
}
</style>
